module.exports = __webpack_public_path__ + "img/lala_scroll06.055a3042.webp";